import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsHistoryManager } from "../managers/HistoryManager";

export class KidsTimeoutPageControl {
	constructor() { }
	static init(categoryView, seriesView) {
		KidsTimeoutPageControl._categoryView = categoryView;
		KidsTimeoutPageControl._seriesView = seriesView;
		$(document.body).on("click", KidsTimeoutPageControl.onTimeoutCancel);
		$(document.body).on("mousemove", KidsTimeoutPageControl.onTimeoutCancel);
		$(document.body).on("keypress", KidsTimeoutPageControl.onTimeoutCancel);
		$(document.body).on("touchend", KidsTimeoutPageControl.onTimeoutCancel);

		TLCEvents.on(
			LS2PAC_CONSTANTS.Events.onTimeout,
			KidsTimeoutPageControl.onTimeout
		);

		TLCEvents.on(
			LS2KIDS_CONSTANTS.Events.onStartAutoCycle,
			KidsTimeoutPageControl.start
		);

		TLCEvents.on(
			LS2PAC_CONSTANTS.Events.onTimeoutCancel,
			KidsTimeoutPageControl.onTimeoutCancel
		);

		KidsTimeoutPageControl.createElement();
	}
	static onTimeout() {
		KidsHistoryManager.navigate(LS2KIDS_CONSTANTS.Urls.home);
	}
	static start() {
		if (KidsTimeoutPageControl.isActive) {
			return;
		}

		$("#" + LS2KIDS_CONSTANTS.Ids.header.searchInput).val("");

		KidsTimeoutPageControl.isActive = true;

		if (LS2KIDS_CONSTANTS.Urls.__start == LS2KIDS_CONSTANTS.Urls.categories) {
			KidsTimeoutPageControl.cycleCategories();
		} else {
			KidsTimeoutPageControl.cycleSeries();
		}
	}
	static onTimeoutCancel() {
		if (KidsTimeoutPageControl.isActive) {
			KidsTimeoutPageControl.isActive = false;

			KidsTimeoutPageControl.hideTimeoutBar();

			clearTimeout(KidsTimeoutPageControl._currentTimeout);

			TLCLogger.info("Stopping autocycle");
		}

		if (KidsTimeoutPageControl._elementShowing) {
			KidsTimeoutPageControl.hideTimeoutBar();
		}
	}
	static cycleCategories() {
		function loop() {
			KidsTimeoutPageControl.hideTimeoutBar();

			if (!KidsTimeoutPageControl.isActive) {
				return;
			}

			if (KidsTimeoutPageControl.hasNextPage(KidsTimeoutPageControl._categoryView._iScroll)) {
				KidsTimeoutPageControl._categoryView._iScroll.next();

				setTimeout(function () {
					window.requestAnimationFrame(function () {
						KidsTimeoutPageControl.showTimeoutBar();
						KidsTimeoutPageControl._currentTimeout = setTimeout(loop, KidsTimeoutPageControl._timeoutLength);
					});
				}, 1000);
			} else {
				KidsTimeoutPageControl.goToPageZero(KidsTimeoutPageControl._categoryView)
					.then(function () {
						KidsTimeoutPageControl.cycleSeries();
					});
			}
		}

		function startCycle() {
			if (!KidsTimeoutPageControl.isActive) {
				return;
			}

			KidsTimeoutPageControl.goToPageZero(KidsTimeoutPageControl._categoryView)
				.then(function () {
					KidsTimeoutPageControl.hideTimeoutBar();
					KidsTimeoutPageControl.showTimeoutBar();

					KidsTimeoutPageControl._currentTimeout = setTimeout(loop, KidsTimeoutPageControl._timeoutLength);
				});
		}

		//	if( KidsTimeoutPageControl._categoryView && KidsTimeoutPageControl._categoryView.isActive ) {
		//		startCycle();
		//	} else {
		TLCEvents.once(LS2KIDS_CONSTANTS.Events.onStartCategoryView, startCycle);

		KidsHistoryManager.navigate(LS2KIDS_CONSTANTS.Urls.categories);
		//	}
	}
	static cycleSeries() {
		function loop() {
			KidsTimeoutPageControl.hideTimeoutBar();

			if (!KidsTimeoutPageControl.isActive) {
				return;
			}

			if (KidsTimeoutPageControl.hasNextPage(KidsTimeoutPageControl._seriesView._iScroll)) {
				KidsTimeoutPageControl._seriesView._iScroll.next();

				setTimeout(function () {
					window.requestAnimationFrame(function () {
						KidsTimeoutPageControl.showTimeoutBar();
						KidsTimeoutPageControl._currentTimeout = setTimeout(loop, KidsTimeoutPageControl._timeoutLength);
					});
				}, 1000);
			} else {
				KidsTimeoutPageControl.goToPageZero(KidsTimeoutPageControl._seriesView)
					.then(function () {
						KidsTimeoutPageControl.cycleCategories();
					});
			}
		}

		function startCycle() {
			if (!KidsTimeoutPageControl.isActive) {
				return;
			}

			KidsTimeoutPageControl.goToPageZero(KidsTimeoutPageControl._seriesView)
				.then(function () {
					KidsTimeoutPageControl.hideTimeoutBar();
					KidsTimeoutPageControl.showTimeoutBar();

					KidsTimeoutPageControl._currentTimeout = setTimeout(loop, KidsTimeoutPageControl._timeoutLength);
				});
		}

		//	if( KidsTimeoutPageControl._seriesView && KidsTimeoutPageControl._seriesView.isActive ) {
		//		startCycle();
		//	} else {
		TLCEvents.once(LS2KIDS_CONSTANTS.Events.onSeriesViewStarted, startCycle);

		KidsHistoryManager.navigate(LS2KIDS_CONSTANTS.Urls.series);
		//	}
	}
	static hasNextPage(iScroll) {
		var currentPage = iScroll.currentPage.pageX + 1;
		var totalPages = iScroll.pages.length;

		return currentPage < totalPages;
	}
	static showTimeoutBar() {
		KidsTimeoutPageControl._element.show();

		KidsTimeoutPageControl._element.addClass('animate');

		if (!window.Modernizr.csstransitions) {
			KidsTimeoutPageControl._elementProgress.animate({
				'width': '100%'
			}, KidsTimeoutPageControl._timeoutLength, 'linear');
		}
	}
	static hideTimeoutBar() {
		KidsTimeoutPageControl._element.removeClass('animate');

		if (!window.Modernizr.csstransitions) {
			KidsTimeoutPageControl._elementProgress
				.stop()
				.css({ 'width': 0 });
		}

		KidsTimeoutPageControl._elementShowing = false;
	}
	static createElement() {
		KidsTimeoutPageControl._elementProgress = $("<div></div>");

		KidsTimeoutPageControl._element = $("<div></div>")
			.append(KidsTimeoutPageControl._elementProgress)
			.addClass("timeout-visual-timer");

		if (!window.Modernizr.csstransitions) {
			KidsTimeoutPageControl._element.addClass('no-transitions');
		}

		$("#" + LS2KIDS_CONSTANTS.Ids.app).append(KidsTimeoutPageControl._element);
	}
	static goToPageZero(view) {
		var deferred = $.Deferred();

		function loop() {
			if (view._iScroll == null) {
				setTimeout(loop, 100);
			} else {
				view._iScroll.goToPage(0, 0, 0);

				deferred.resolve();
			}
		}

		loop();

		return deferred.promise();
	}
}

KidsTimeoutPageControl._timeoutLength = 20000;

KidsTimeoutPageControl._elementShowing = false;

KidsTimeoutPageControl._element = null;
KidsTimeoutPageControl._elementProgress = null;











